import temperatureUnitsEnums from '../enums/temperatureUnitsEnum';

export function getTemperatureValue(value, temperatureUnit) {
  value = parseFloat(value);
  if (temperatureUnit === temperatureUnitsEnums.FAHRENHEIT) {
    return ConvertToFahrenheit(value);
  } else {
    return value.toFixed(1);
  }
}

export function getTemperatureValueWithUnits(value, temperatureUnit) {
  value = getTemperatureValue(value, temperatureUnit);
  if (temperatureUnit === temperatureUnitsEnums.FAHRENHEIT) {
    return `${value} ${GlobalUnitPresentationFahrenheitSymbol()}`;
  } else {
    return `${value} ${GlobalUnitPresentationCelsiusSymbol()}`;
  }
}

export function ConvertToFahrenheit(celsius) {
  return FixedToOneDecimal((celsius * 9) / 5 + 32);
}

export function ConvertToCelsius(fahrenheit) {
  return FixedToOneDecimal(((fahrenheit - 32) * 5) / 9);
}

export function ConvertToCelsiusMultiDecimal(fahrenheit) {
  return ((fahrenheit - 32) * 5) / 9;
}

export function ConvertCelsiusArrayToFahrenheit(array) {
  return array.map((item) => ConvertToFahrenheit(item));
}

export function ConvertFahrenheitArrayToCelsius(array) {
  return array.map((item) => ConvertToCelsius(item));
}

export function FixedToOneDecimal(value) {
  return Number(value.toFixed(1)); // This is a hazard. Not equivalent to Number.parseFloat(x).toFixed(1). Do not modify parens to Number(value).toFixed(1))
}

export function FixedToOneDecimalWithArray(values) {
  return values.map((value) => FixedToOneDecimal(value));
}

export function concatWithTemperatureUnitSymbol(value, temperatureUnit) {
  return `${value} ${
    temperatureUnit === temperatureUnitsEnums.FAHRENHEIT
      ? GlobalUnitPresentationFahrenheitSymbol()
      : GlobalUnitPresentationCelsiusSymbol()
  }`;
}

export function concaWithFahrenheitSymbol(value) {
  return `${value} ${GlobalUnitPresentationFahrenheitSymbol()}`;
}

export function GlobalUnitPresentationFahrenheitSymbol() {
  return `°${temperatureUnitsEnums.FAHRENHEIT}`;
}

export function GlobalUnitPresentationCelsiusSymbol() {
  return `°${temperatureUnitsEnums.CELSIUS}`;
}

export function FahrenheitToGlobalUnitsPresentation(fahrenheit) {
  return `${fahrenheit} ${GlobalUnitPresentationFahrenheitSymbol()}`;
}

export default function CelsiusToGlobalUnitsPresentation(celsius) {
  return `${ConvertToFahrenheit(celsius)} ${GlobalUnitPresentationFahrenheitSymbol()}`;
}
